/* Pampera · Regalo de Halloween 2026 (MX y US)
 * Con calzado en el carrito, del 30/10 00:00 al 1/11 23:59 (hora CDMX), añade a 0:
 *   - 1 plantilla de regalo
 *   - 1 guía de outfits en PDF por género del calzado (hombre / mujer)
 * Sin calzado, los quita. Se carga como ScriptTag (no toca el tema).
 * Prueba fuera de fechas: abrir la tienda con ?regalo_halloween=test (se guarda en la sesión).
 * Documentación: README.md de esta carpeta.
 */
(function () {
  'use strict';
  var TIENDAS = {
    'pampera-shop-mx.myshopify.com': {
      plantilla: 67698184978729,
      guia: { hombre: 67698185077033, mujer: 67699822690601 },
      tagCalzado: 'calzado', tagMujer: 'mujer'
    },
    'pampera-us.myshopify.com': {
      plantilla: 50041095225603,
      guia: { hombre: 50041095291139, mujer: 50042497204483 },
      tagCalzado: 'footwear', tagMujer: 'women'
    }
  };
  var INICIO = Date.parse('2026-10-30T06:00:00Z'); // 30/10 00:00 CDMX
  var FIN = Date.parse('2026-11-02T06:00:00Z');    // 1/11 23:59 CDMX (todo el finde; Álvaro 28/10)
  var MARCA = 'halloween-2026';

  var tienda = window.Shopify && TIENDAS[window.Shopify.shop];
  if (!tienda) return;

  var prueba = false;
  try {
    if (/[?&]regalo_halloween=test\b/.test(location.search)) sessionStorage.setItem('regalo_halloween', 'test');
    prueba = sessionStorage.getItem('regalo_halloween') === 'test';
  } catch (e) {}
  var ahora = Date.now();
  var enFechas = ahora >= INICIO && ahora < FIN;
  // Fuera de fechas solo actúa para quitar regalos que se hubieran quedado en el carrito.
  var activo = enFechas || prueba;
  if (!activo && ahora < INICIO) return; // antes del 30/10 no hace nada

  var raiz = (window.Shopify.routes && window.Shopify.routes.root) || '/';
  var fetchOriginal = window.fetch.bind(window);
  var cacheTags = {};
  var enCurso = null, pendiente = false;

  function log() { if (prueba) try { console.log.apply(console, ['[regalo-halloween]'].concat([].slice.call(arguments))); } catch (e) {} }

  function json(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json', 'X-Regalo-Halloween': '1' }, opts.headers || {});
    return fetchOriginal(url, opts).then(function (r) { return r.json(); });
  }

  function tagsDe(handle) {
    if (!cacheTags[handle]) {
      cacheTags[handle] = json(raiz + 'products/' + handle + '.js')
        .then(function (p) { return (p.tags || []).map(function (t) { return String(t).toLowerCase(); }); })
        .catch(function () { return []; });
    }
    return cacheTags[handle];
  }

  function esRegalo(item) { return item.properties && item.properties._regalo === MARCA; }

  function sincronizar() {
    return json(raiz + 'cart.js').then(function (cart) {
      var normales = cart.items.filter(function (i) { return !esRegalo(i); });
      var regalos = cart.items.filter(esRegalo);
      return Promise.all(normales.map(function (i) { return tagsDe(i.handle); })).then(function (tags) {
        var generos = {};
        tags.forEach(function (t) {
          if (t.indexOf(tienda.tagCalzado) === -1) return;
          generos[t.indexOf(tienda.tagMujer) !== -1 ? 'mujer' : 'hombre'] = true;
        });
        var hayCalzado = activo && Object.keys(generos).length > 0;

        // Lo que debería haber: variante -> 1
        var deseado = {};
        if (hayCalzado) {
          deseado[tienda.plantilla] = 1;
          Object.keys(generos).forEach(function (g) { deseado[tienda.guia[g]] = 1; });
        }

        var cambios = [];   // [key, cantidad] para change.js
        var visto = {};
        regalos.forEach(function (i) {
          var quiere = deseado[i.variant_id] && !visto[i.variant_id] ? 1 : 0;
          if (quiere) visto[i.variant_id] = true;
          if (i.quantity !== quiere) cambios.push([i.key, quiere]);
        });
        var nuevos = Object.keys(deseado).filter(function (v) { return !visto[v]; });

        if (!cambios.length && !nuevos.length) return false;
        log('cambios', cambios, 'nuevos', nuevos);

        var p = Promise.resolve();
        cambios.forEach(function (c) {
          p = p.then(function () { return json(raiz + 'cart/change.js', { method: 'POST', body: JSON.stringify({ id: c[0], quantity: c[1] }) }); });
        });
        if (nuevos.length) {
          p = p.then(function () {
            return json(raiz + 'cart/add.js', {
              method: 'POST',
              body: JSON.stringify({ items: nuevos.map(function (v) { return { id: Number(v), quantity: 1, properties: { _regalo: MARCA } }; }) })
            });
          });
        }
        return p.then(function () { return true; });
      });
    });
  }

  function refrescarTema() {
    try { sessionStorage.removeItem('cdCachedCart'); } catch (e) {}
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    window.dispatchEvent(new CustomEvent('cart:item-added', { detail: {} }));
  }

  function programar() {
    if (enCurso) { pendiente = true; return enCurso; }
    enCurso = sincronizar()
      .then(function (cambio) { if (cambio) refrescarTema(); })
      .catch(function (e) { log('error', e); })
      .then(function () {
        enCurso = null;
        if (pendiente) { pendiente = false; programar(); }
      });
    return enCurso;
  }

  // Tras cada cambio del carrito que haga el tema, revisar los regalos.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var propio = init && init.headers && init.headers['X-Regalo-Halloween'];
    var res = fetchOriginal(input, init);
    if (!propio && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
      res.then(function () { setTimeout(programar, 50); }, function () {});
    }
    return res;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', programar);
  else programar();
})();
